<template>
    <b-card body-class="p-0">
        <b-card-header>
            <h5 class="mb-0">
                <font-awesome-icon
                    v-if="creatorGallery.saved"
                    class="text-primary"
                    icon="fa-solid fa-check-circle"
                />
                <font-awesome-icon
                    v-else
                    icon="fa-solid fa-circle"
                ></font-awesome-icon>
                {{ $t("Details") }}
            </h5>
        </b-card-header>
        <b-card-body>
            <div class="">
                {{ $t("Gallery Name") }}
            </div>
            <b-form-input
                @input="madeChanges"
                v-model="name"
                :placeholder="$t('Give your gallery a unique name')"
                maxlength="255"
                autocomplete="off"
            ></b-form-input>

            <b-row class="mt-2">
                <b-col cols="6">
                    <div>
                        {{ $t("Price in Credits") }}
                    </div>
                    <b-form-input
                        @input="madeChanges"
                        v-model="price"
                        :placeholder="$t('1-100')"
                        type="number"
                        autocomplete="off"
                    ></b-form-input>
                </b-col>
                <b-col cols="6">
                    <div>
                        {{ $t("My Currency Value") }}
                    </div>
                    <b-form-input
                        :value="local"
                        readonly
                        class="text-center text-primary"
                    />
                </b-col>
            </b-row>

            <b-alert variant="danger" show v-if="error">
                {{ error }}
            </b-alert>

            <b-btn
                v-if="changed"
                @click="save"
                variant="primary"
                pill
                size="lg"
                block
                class="mt-3"
            >
                {{ $t("Save") }}
            </b-btn>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            changed: false,
            name: null,
            price: null,
            error: null,
            local: null,
            amount: null,
        };
    },
    created() {
        this.name = this.creatorGallery.name;
        this.price = this.creatorGallery.price;

        if (!this.creatorGallery.saved) {
            this.changed = true;
        }

        this.convertCredits();
    },
    computed: {
        ...mapState("creatorGallery", ["creatorGallery"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    watch: {
        price(value) {
            if (value) {
                this.convertCredits();
            }
        },
    },
    methods: {
        madeChanges() {
            this.changed = true;
        },
        mediaUploaded(ano) {
            console.log(ano);
        },
        save() {
            this.error = null;

            this.api
                .post("/creatorGallery/save", {
                    creatorGalleryId: this.creatorGallery.id,
                    name: this.name,
                    price: this.price,
                })
                .then((response) => {
                    this.changed = false;

                    if (response?.data?.creatorGallery) {
                        this.$store.commit(
                            "creatorGallery/setCreatorGallery",
                            response.data.creatorGallery
                        );
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.errors?.price?.length) {
                        this.error = error.response.data.errors.price.join(",");
                    }

                    if (error?.response?.data?.errors?.name?.length) {
                        this.error = error.response.data.errors.name.join(",");
                    }
                });
        },
        convertCredits() {
            this.local = null;
            this.amount = null;

            this.api
                .post("/credit/convert", {
                    userId: this.onboardingUser.id,
                    amount: this.price,
                })
                .then((response) => {
                    if (response?.data?.sendAmount?.local) {
                        this.local = response.data.sendAmount.local;
                        this.amount = response.data.sendAmount.amount;
                    }
                });
        },
    },
    components: {},
};
</script>